module.exports = __webpack_public_path__ + "img/insufficient-balance.dd08edd.png";